export default __webpack_public_path__ + "static/media/Full_Skyline_No_Clouds.b8ac782e.png";